import { combineReducers } from '@reduxjs/toolkit';
import { reducer as stats } from './stats';
import { reducer as auth } from './auth';
import { reducer as passwordReset } from './password-reset';
import { reducer as signUp } from './sign-up';
import { reducer as user } from './user';

import { reducer as network } from './network';
import { reducer as formEntry } from './form-entry';
import { reducer as pwa } from './pwa';
import { reducer as applications } from './applications';

const rootReducer = combineReducers({
    stats,
    auth,
    passwordReset,
    signUp,
    user,
    network,
    formEntry,
    pwa,
    applications,
});

export default rootReducer;
